import { render, staticRenderFns } from "./ExchangeRuleSettings.vue?vue&type=template&id=ad73faba&scoped=true&"
import script from "./ExchangeRuleSettings.vue?vue&type=script&lang=js&"
export * from "./ExchangeRuleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad73faba",
  null
  
)

export default component.exports